module.exports = __webpack_public_path__ + "static/mobile_02@2x-0c4c6a25d07ac33a146647fdea0f54cd.png";